import React, { Component } from 'react'
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

const style = theme => ({
  root: {
    borderRadius: 30,
    height: 44
  },
  label:{
    fontWeight: 200,
    fontSize: '1em'
  }
})

const ChowbusButton = props => {
  const {className, children, classes, ...rest} = props
  const classNames = `${className ? className : ''}`
  return <Button classes={{root: classes.root, label: classes.label}} className={classNames} {...rest}>{children}</Button>
}

export default withStyles(style)(ChowbusButton)
